import { useParams, useLocation, Navigate, Outlet } from 'react-router-dom';
import { isPublicPath, ROUTES } from '@/common/auth-routes';
import { isValidTenantSlug } from '@/common/tenant-utils';
import { TenantContext } from './tenant-context-definition';
import type { TenantContextValue } from './tenant-context-definition';

export type { TenantContextValue };

export function TenantProvider() {
  const { tenant } = useParams<{ tenant: string }>();
  const location = useLocation();

  const isValidTenant = isValidTenantSlug(tenant);

  // Only redirect to tenant-selection for authenticated routes.
  // Public paths (login, auth/error, onboarding) render regardless of tenant validity.
  if (!isValidTenant && !isPublicPath(location.pathname)) {
    return <Navigate to={ROUTES.TENANT_SELECTION} replace />;
  }

  const value: TenantContextValue = {
    tenant: tenant ?? '',
    isValidTenant,
  };

  return (
    <TenantContext.Provider value={value}>
      <Outlet />
    </TenantContext.Provider>
  );
}
